module.exports = __webpack_public_path__ + "static/img/validada.0bc83d47.png";